module.exports = __webpack_public_path__ + "img/icon-facebook.a050b483.svg";